import { mockCardPaymentOption, mockQuoteDetails } from '@domgen/dgx-fe-basket';
import { CompletedQuoteDetails } from '../../models/completed-quote/completed-quote-details.interface';
import { mockCheckoutCompletedQuoteConfirmation } from '../checkout-completed-item/checkout-completed-quote-confirmation.mock';

export const mockCompletedQuoteDetails: CompletedQuoteDetails = {
  ...mockQuoteDetails,
  ...mockCheckoutCompletedQuoteConfirmation,
  purchasedPaymentOption: mockCardPaymentOption,
};
